import { GET_IN_TOUCH_REQUEST_TYPES } from '@clearverify/constants';

export const REQUEST_TYPES_OPTIONS = Object.values(GET_IN_TOUCH_REQUEST_TYPES).map(
  requestTypeValue => ({
    label: requestTypeValue,
    value: requestTypeValue,
  }),
);

export const VERIFIER_TYPES_OPTIONS = REQUEST_TYPES_OPTIONS.filter(
  requestType => requestType.label !== GET_IN_TOUCH_REQUEST_TYPES.dataDispute,
);
